import { Grid } from "@mantine/core"
import { UseFormReturnType } from "@mantine/form"

import { RenderField } from "~/pages/Admin/components/RenderField"
import { FormRowConfig } from "~/pages/Admin/components/form.types"

export const FormRow = <T extends Record<string, unknown>>({
  rowConfig,
  form,
}: {
  rowConfig: FormRowConfig
  form: UseFormReturnType<T>
}) => {
  return (
    <Grid gutter={rowConfig.spacing || "md"} w="100%">
      {rowConfig.fields.map((field, index) => (
        <Grid.Col
          key={index}
          span={field.span || Math.floor(12 / rowConfig.fields.length)}
        >
          <RenderField field={field} form={form} />
        </Grid.Col>
      ))}
    </Grid>
  )
}
